import Helpers from './Helpers';
import LoggedInUser from './LoggedInUser';

class Auth {
  static isLoggedIn(){
    return LoggedInUser.getInfo() != null;
  }

  static canOnlySeeOKRs(){
    return LoggedInUser.getInfo().user.swipecast_user_id == '22640c47870c96f952ac31f651ce678a6b62d7593a07';
  }

  static logIn(email, password){
    return fetch(Helpers.endpoint("/login"), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: email,
        password: password,
        client: 'desktop'
      })
    })
  }

  static logOut(){
    return fetch(Helpers.endpoint("/logout"), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        auth_token: LoggedInUser.getInfo().auth_token
      })
    })
  }
}

export default Auth;
